<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-toggle-menu-button></app-toggle-menu-button>
    </ion-buttons>
    <ion-title>
      <div class="ion-text-wrap">
        {{ texts.material.catalogueTitle | translate }}
      </div>
    </ion-title>
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar
      #searchInput
      (ionInput)="searchFilter$.next($event.target.value)"
    ></ion-searchbar>
    <ion-buttons slot="end">
      <app-filter-selection
        [filterOptions]="filterOptions$ | async"
        [service]="materialCatalogueItemsService"
        cssClass=""
      >
      </app-filter-selection>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-progress-bar
  *ngIf="(materialCatalogueList$ | async) === false || (isLoading$ | async)"
  type="indeterminate"
></ion-progress-bar>

<ion-content>
  <div
    (onEnterEvent)="onEnter()"
    (onEscape)="onCancelClick()"
    [dataSource$]="materialCatalogueList$"
    [selectedIndex]="selectedIndex"
    id="table-element"
    appTableRowMovement
  >
    <app-material-catalog-list-table
      (onClickEvent)="onClick($event)"
      (onHoverEvent)="onHover($event)"
      *ngIf="showTable$ | async"
      [materialCatalogueList$]="materialCatalogueList$"
      [selectedIndex$]="selectedIndex"
      [tableColumns$]="tableColumns$"
    ></app-material-catalog-list-table>

    <app-material-catalog-list-item
      (onClickEvent)="onClick($event)"
      (onHoverEvent)="onHover($event)"
      *ngIf="(showTable$ | async) === false"
      [materialCatalogueList$]="materialCatalogueList$"
      [selectedIndex$]="selectedIndex"
      [tableColumns$]="tableColumns$"
    >
    </app-material-catalog-list-item>
  </div>
  <ion-infinite-scroll
    (ionInfinite)="loadData($event)"
    *ngIf="(lastPage$ | async) === false"
    threshold="100px"
  >
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="{{ texts.general.loadMore | translate }}"
    >
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="primary">
      <ion-tab-button
        (click)="onCancelClick()"
        class="admia-toolbar-buttons"
        slot="end"
      >
        <ion-icon name="arrow-back"></ion-icon>
        <ion-label>
          <ion-text>
            {{ texts.general.cancel | translate }}
          </ion-text>
        </ion-label>

        <ion-ripple-effect></ion-ripple-effect>
      </ion-tab-button>
      <ion-buttons slot="end">
        <app-column-selection
          [service]="materialCatalogueItemsService"
          [tableColumns]="tableColumns$ | async"
          cssClass=""
        ></app-column-selection>
      </ion-buttons>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
